<template>
    <div class="footerWrapper">
        <div class="footerLeft">Copyright © 2011-{{currentYear}}北京泽云瑞弘信息技术有限公司 <span style="cursor: pointer;" @click="toFiling">京ICP备19045213号-1</span></div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            currentYear: new Date().getFullYear()
        }
    },
    methods: {
        toFiling() {
            window.open("https://beian.miit.gov.cn", '_blank')
        }
    }
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 1200px) {
    .footerWrapper {
        display: flex;
        justify-content: center;
    }
}

.footerWrapper {
    width: 100%;
    height: 65px;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    color: #999999;
    font-size: 14px;
}
</style>